import { render, staticRenderFns } from "./AddShooting.vue?vue&type=template&id=78533822&scoped=true"
import script from "./AddShooting.vue?vue&type=script&lang=js"
export * from "./AddShooting.vue?vue&type=script&lang=js"
import style0 from "./AddShooting.vue?vue&type=style&index=0&id=78533822&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78533822",
  null
  
)

export default component.exports